// compare existing uid with the one passed in
const compareUid = (uid) => (existing) => existing.uid === uid;

export default compareUid;
